import { useCifraClient } from '@/api/cifra-client';

/**
 * Esta llamada es a una API de un controlador de Cifra, no de ninguna api pública
 * Es la llamada a asiganaturas/json que es un método muy viejo que se usa para
 * obtener las asignaturas
 */

const { cifraClient } = useCifraClient();

export default {
  guardarOptativas(data) {
    return cifraClient.post(
      '/matriculas/update_optativas',
      data,
    );
  },
};
